<form
  *ngIf="formInitialized"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <div class="grid">
    <app-form-field-wrapper
      [label]="'Zuordnung an'"
      [name]="'parent'"
      [colSize]="7"
      [formField]="form.get('parent')"
      *ngIf="dataLayerTypeStore.asArray() as dataLayerTypes">
      <app-type-dropdown
        [class.ng-touched]="parent"
        mode="all"
        formControlName="parent"
        (selectionChange)="onParentChange($event)"></app-type-dropdown>
    </app-form-field-wrapper>

    <app-form-field-wrapper
      [label]="'Jahr'"
      [name]="'year'"
      [colSize]="2"
      [formField]="form.get('year')">
      <input
        pInputText
        id="year"
        type="number"
        formControlName="year"
        class="p-input" />
    </app-form-field-wrapper>

    <app-form-field-wrapper
      [label]="'öffentlich sichtbar'"
      [name]="'published'"
      [colSize]="3">
      <p-inputSwitch formControlName="published"></p-inputSwitch>
    </app-form-field-wrapper>
  </div>
  <div class="grid">
    <app-form-field-wrapper
      [label]="'Geschützte Informationen'"
      [name]="'description'">
      <textarea
        rows="1"
        cols="30"
        pInputTextarea
        formControlName="description"></textarea>
    </app-form-field-wrapper>
  </div>

  <p-divider />

  <app-form-footer
    [cancelLevel]="cancelLevel"
    [hideCancelLink]="disableCancelLink"
    [showRemoveButton]="
      !!(
        itemToEdit &&
        permissionService.checkDataLayerRights(itemToEdit.parent, 'remove')
      )
    "
    [isEditMode]="!!itemToEdit"
    (cancel)="cancel.emit()"
    (removeClick)="itemToEdit ? removeDataLayer(itemToEdit) : undefined" />
</form>
